import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DivButton from '../../layout/divbutton/DivButton'
import WarehouseFormStyle from './css/WarehouseFormStyle'
import ModalWindow  from '../../layout/modalwindow/ModalWindow'

function WarehouseForm(props) {
  const { app, getWarehouses, getWarehouseById, saveWarehouse, deleteWarehouse } = props
  const warehouseNameRef = useRef(null)
  const [warehouses, setWarehouses] = useState([])
  const initWarehouse = { name: '' }
  const [warehouse, setWarehouse] = useState(initWarehouse)

  const onClickWarehouseItem = async (e) => {
    const warehouse_id = e.target.closest('.warehouse-item').id
    const delete_button = e.target.closest('.delete-button')

    if (delete_button) return

    // Edit here
    setWarehouse(await getWarehouseById(app, warehouse_id))
    warehouseNameRef.current.focus()
  }


  const onClickAdd = async (e) => {
    //Don't add empty names (space, spaces)
    if (warehouse.name.trim() === '') {
      setWarehouse({ ...warehouse, name: '' })
      warehouseNameRef.current.focus()
      return
    }

    // Don't add warehouse names that is --All--
    if (warehouse.name.trim().toLowerCase() === '--all--') {
      ReactDOM.render (
        <ModalWindow
          id='mw-child'
          header="Add Warehouse"
          height='30'
          width='35'
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>The warehouse name <b>{warehouse.name}</b> is not allowed.</div>
              <br />
              <div>Please choose a different name.</div>
            </div>
            <div className='button-container'>
              <button
                onClick={() => {
                  warehouseNameRef.current.focus()
                  ReactDOM.unmountComponentAtNode(document.getElementById('mw-parent'))
                }} className='pospro-action-btn top-anchor'>
                Ok
              </button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('mw-parent')
      )
      return
    }

    // Find if there is a name already exist on the warehouses list
    const warehouse_exist = (warehouse._id)
    ? warehouses
      .filter(wh => wh._id !== warehouse._id)
      .find(wh => wh.name.toLowerCase() === warehouse.name.toLowerCase())
    : warehouses
      .find(wh => wh.name.toLowerCase() === warehouse.name.toLowerCase())

    if (warehouse_exist) {
      ReactDOM.render (
        <ModalWindow
          id='mw-child'
          header="Add warehouse"
          height='30'
          width='35'
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>The warehouse name <span style={{fontWeight: 'bold'}}>{warehouse.name}</span> already exist.</div>
              <div>Please choose a different name.</div>
            </div>
            <div className='button-container'>
              <button
                onClick={() => {
                  warehouseNameRef.current.focus()
                  ReactDOM.unmountComponentAtNode(document.getElementById('mw-parent'))
                }}
                className='pospro-action-btn top-anchor'>
                Ok
              </button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('mw-parent')
      )
    } else {
      await saveWarehouse(app, warehouse)
      reloadWarehouses()    
    }
  }

  const onClickCancel = (e) => {
    setWarehouse(initWarehouse)
    warehouseNameRef.current.focus()
  }

  const onClickDelete = (e) => {
    const warehouse_id = e.target.closest('.warehouse-item').id
    const onClick = async (button) => {
      if (button === 'Yes') {
        await deleteWarehouse(app, warehouse_id)
        reloadWarehouses()
      }
      ReactDOM.unmountComponentAtNode(document.getElementById('mw-parent'))
    }
    // show messagebox here
    ReactDOM.render (
      <ModalWindow
        id='mw-child'
        height='40'
        width='40'
        header="Delete Warehouse"
        footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div className='msgbox-warning'>
                <FontAwesomeIcon icon='exclamation-circle'/>&nbsp;<div>Warning!</div>
              </div>
              <br />
              <div>Deleting warehouse will also remove all the products inventory in it!</div>
              <br />
              <div>Are you sure you want to continue</div>
            </div>
            <div className='button-container'>
              <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
              <button onClick={() => { onClick('Yes') }} className='pospro-action-btn bottom-anchor'>Yes</button>
            </div>
          </div>
       </ModalWindow>,
       document.getElementById('mw-parent')
    )
  }

  const onClickClose = (e) => {
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
  }

  const reloadWarehouses = async () => {
    const warehouse_list = await getWarehouses(app)
    setWarehouses(warehouse_list)
    setWarehouse(initWarehouse)
    warehouseNameRef.current.focus()
  }

  useEffect(() => {
    reloadWarehouses()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <React.Fragment>
      <div id='warehouse-container'>
        <div id='warehouse-form-wrapper'>
          <div id='warehouse-form'>
            <label>Add new warehouse</label>
            <input
              className='top-anchor'
              ref={warehouseNameRef}
              type='text'
              onChange={(e) => { setWarehouse({ ...warehouse, name: e.target.value }) }}
              value={warehouse.name}
              placeholder='warehouse name'/>
            <div className='button-container'>
              <button
                onClick={onClickAdd}
                className='pospro-action-btn'>
                {(warehouse._id) ? <span>Update</span> : <span>Add</span>}
              </button>
              { (warehouse._id) ?
                <button
                  onClick={onClickCancel}
                  className='pospro-action-btn'>
                  Cancel
                </button>
                : null
              }
            </div>
          </div>
          <div id='warehouse-list-wrapper'>
            <div id='warehouse-list'>
              {
                warehouses.map(warehouse => (
                  <DivButton
                    key={warehouse._id}
                    disabled={(warehouse.name === 'Main Warehouse')}
                    id={warehouse._id}
                    onClick={onClickWarehouseItem}
                    className={(warehouse.name === 'Main Warehouse') ? 'warehouse-item disabled' : 'warehouse-item active'}>
                    <div className='warehouse-icon'>
                      <FontAwesomeIcon icon='warehouse'/>
                    </div>
                    <div className='warehouse-details-wrapper'>
                      <div className='warehouse-details-title'>{warehouse.name}</div>
                      <div>Date/Time Created: {new Date(warehouse.date_time_created).toLocaleString()}</div>
                      <div>Warehouse ID: {warehouse._id.toUpperCase()}</div>
                    </div>
                    <div className='delete-button-container'>
                      <button
                        style={{visibility: (warehouse.name === 'Main Warehouse') ? 'hidden' : 'visible'}}
                        onClick={onClickDelete}
                        title='delete warehouse'
                        className='delete-button'>
                        <FontAwesomeIcon icon='times'/>
                      </button>
                    </div>
                  </DivButton>
                ))
              }
            </div>
            <div id='warehouse-total-summary'>Total Warehouse: {warehouses.length} </div>
          </div>
        </div>
        <div className='button-container'>
          <button
            className='pospro-action-btn bottom-anchor'
            onClick={onClickClose}>
            Close
          </button>
        </div>
      </div>
      <WarehouseFormStyle />
    </React.Fragment>
  )
}

export default React.memo(WarehouseForm)